import axios from 'axios';

export const credentialsSupportWorkflow = (credentials, workflow) => (
  Array.isArray(credentials)
  && credentials.some((credential) => (
    Array.isArray(credential.supports_workflows)
    && credential.supports_workflows.includes(workflow)
  ))
);

export const fetchStandaloneTaskSupport = async () => {
  try {
    const response = await axios.get('/api/v1/emr_integration_credentials');
    return credentialsSupportWorkflow(response.data.credentials, 'task_creation');
  } catch (error) {
    console.error('Failed to fetch EMR credential capabilities', error);
    return false;
  }
};

export const canUseStandaloneTask = ({
  hasEmrIntegrationCredential,
  credentialSupportsStandaloneTask,
  autoUploadEmr,
}) => {
  if (hasEmrIntegrationCredential) {
    return credentialSupportsStandaloneTask;
  }

  return autoUploadEmr !== 'AdvancedMD';
};
